// Coordonnées uniques : les moteurs et les IA pénalisent les informations
// contradictoires d'une page à l'autre.
export const SITE = {
  url: 'https://www.expomis.com',
  orgId: 'https://www.expomis.com/#organisation',
  name: 'Expomis',
  phone: '+352 661 181 082',
  phoneHref: 'tel:+352661181082',
  email: 'info@expomis.com',
  address: '69, rue de Hobscheid, L-8422 Steinfort, Luxembourg',
  hours: ['Lun-Ven : 9h-18h', 'Samedi : 9h-16h', 'Urgences : 24h/24'],
};

export const AREAS = {
  lu: [{ '@type': 'Country', name: 'Luxembourg' }],
  be: [{ '@type': 'AdministrativeArea', name: 'Province de Luxembourg, Belgique' }],
};
AREAS.both = [...AREAS.lu, ...AREAS.be];
